import { createAuthRequestInit } from '../utils/auth';
import { API_BASE } from '../config/api';

export interface SubscriptionAnalytics {
  totalSubscriptions: number;
  activeSubscriptions: number;
  churnedSubscriptions: number;
  mrr: number;
  arr: number;
  churnRate: number;
  averageSubscriptionValue: number;
}

export async function getSubscriptionAnalytics(): Promise<SubscriptionAnalytics> {
  const res = await fetch(`${API_BASE}/analytics/subscriptions`, createAuthRequestInit());
  if (!res.ok) {
    throw new Error(`Failed to load analytics (Status: ${res.status})`);
  }
  const json = await res.json();
  return json.data as SubscriptionAnalytics;
}


